// extracted by mini-css-extract-plugin
export default {"container":"index__container__XBSlk","iconWrap":"index__iconWrap__mCRNv","icon":"index__icon__WW3t4"};